/**
 * @generated SignedSource<<1f05a50a15753c67b4b42e99a5cdfd85>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum CommentsType {
  FOOTER = "FOOTER",
  INLINE = "INLINE",
}
export enum SummaryType {
  PAGE = "PAGE",
  BLOGPOST = "BLOGPOST",
}
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery_getCommentsSummary_SmartFeaturesCommentsSummary =
  {
    __typename?: "SmartFeaturesCommentsSummary";
    contentId: string;
    summary: string;
    summaryId: string;
    language: string;
  };
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery_Query =
  {
    __typename?: "Query";
    getCommentsSummary: useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery_getCommentsSummary_SmartFeaturesCommentsSummary | null;
  };
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQueryVariables =
  Exact<{
    contentId: Scalars["ID"]["input"];
    contentType: SummaryType;
    commentsType: CommentsType;
  }>;
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery =
  useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery_Query;
